import React from 'react';
import { Badge } from 'react-bootstrap';

const PerformanceIndicator = ({ 
  isSlowConnection, 
  prefersReducedMotion, 
  cacheStatus,
  imageCount 
}) => {
  if (process.env.NODE_ENV !== 'development') {
    return null; // Показываем только в режиме разработки
  }

  return (
    <div 
      style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        zIndex: 9999,
        backgroundColor: 'rgba(0,0,0,0.8)',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '8px',
        fontSize: '12px',
        fontFamily: 'monospace'
      }}
    >
      <div style={{ marginBottom: '4px' }}>
        <strong>Performance Status</strong>
      </div>
      
      <div style={{ marginBottom: '2px' }}>
        Connection: 
        <Badge 
          bg={isSlowConnection ? 'warning' : 'success'} 
          style={{ marginLeft: '4px' }}
        >
          {isSlowConnection ? 'Slow' : 'Fast'}
        </Badge>
      </div>
      
      <div style={{ marginBottom: '2px' }}>
        Motion: 
        <Badge 
          bg={prefersReducedMotion ? 'info' : 'secondary'} 
          style={{ marginLeft: '4px' }}
        >
          {prefersReducedMotion ? 'Reduced' : 'Normal'}
        </Badge>
      </div>
      
      <div style={{ marginBottom: '2px' }}>
        Cache: 
        <Badge 
          bg={cacheStatus === 'hit' ? 'success' : cacheStatus === 'miss' ? 'warning' : 'secondary'} 
          style={{ marginLeft: '4px' }}
        >
          {cacheStatus || 'Unknown'}
        </Badge>
      </div>
      
      <div>
        Images: 
        <Badge bg="info" style={{ marginLeft: '4px' }}>
          {imageCount || 0}
        </Badge>
      </div>
    </div>
  );
};

export default PerformanceIndicator;
